export interface IOsiServiceSaldoTableViewModel {
  saveSaldo: any;
}

export const IOsiServiceSaldoTableVmToken = Symbol.for('IOsiServiceSaldoTableViewModel');
